import Vue from "vue";

/**
 * Class Status Service
 */
export default class StatusService extends Vue {
  private customActions = {
    group: {
      method: "GET",
      url: "lead/status/group/{groupId}"
    }
  };
  private resource: any = this.$resource(
    "lead/status{/id}",
    {},
    this.customActions
  );

  // GET all
  public index() {
    return this.resource.get({}).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET one
  public show(id: number) {
    return this.resource.get({ id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET one
  public group(groupId: number) {
    return this.resource.group({ groupId }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // POST
  public store(data: any) {
    return this.resource.save({}, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // PUT
  public update(id: number, data: any) {
    return this.resource.update({ id }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // DELETE
  public delete(id: number) {
    return this.resource.delete({ id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }
}
